<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useStudentStore } from '@/stores/student'
import { useDisplay } from 'vuetify'

const authStore = useAuthStore()
const studentStore = useStudentStore()
const { is_shadowing } = storeToRefs(authStore)
const { xs, sm } = useDisplay()
const isOpen = ref(true)

const dialogMaxWidth = computed(() => {
  if (xs.value) return '95vw'
  if (sm.value) return '80vw'
  return 750
})

const showModal = computed({
  get: () => isOpen.value && (studentStore.is_trial || is_shadowing.value),
  set: (val) => { isOpen.value = val }
})

const close = () => {
  isOpen.value = false
}
</script>

<template>
  <VDialog
    v-model="showModal"
    :max-width="dialogMaxWidth"
    content-class="startup-modal__content"
  >
    <VCard
      :class="[
        'position-relative border startup-modal__card rounded-lg',
        { 'startup-modal__card--shadowing': is_shadowing }
      ]"
    >
      <div class="d-flex justify-end pa-2 pt-3 pe-3 position-absolute" style="top: 0; right: 0">
        <button
          type="button"
          class="startup-modal__close-btn"
          aria-label="Close"
          @click="close"
        >
          <VIcon icon="mdi-close" size="12" />
        </button>
      </div>
      <VCardText
        v-dompurify-html="is_shadowing ? $t('pages.non_standard_student.logged_in_as_shadowing', { studentName: studentStore.full_name }) : $t('pages.non_standard_student.logged_in_as_trial')"
        class="pt-6 px-6 pb-6"
      />
    </VCard>
  </VDialog>
</template>

  <!-- Positioning styles for .startup-modal__content in _startup-modal.scss
  (styles in global stylesheet to target teleported overlay) -->
<style lang="scss" scoped>
.startup-modal__card {
  border-width: 0.2rem !important;
  border-color: rgb(var(--v-theme-trial)) !important;

  &--shadowing {
    border-color: rgb(var(--v-theme-info)) !important;
  }
}

.startup-modal__close-btn {
  align-items: center;
  border-radius: 50%;
  background-color: rgb(var(--v-theme-grey-500));
  color: white;
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;
}

.startup-modal__close-btn:hover {
  background-color: rgb(var(--v-theme-grey-600));
}
</style>
